import React from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import useDecisionTreeRunContext from './DecisionTreeRunContext/useDecisionTreeRunContext';

export const DecisionTreePreviewContext = React.createContext<boolean>(false);

export default function useDecisionTreePreviewContext() {
  return React.useContext(DecisionTreePreviewContext);
}

export function DecisionTreePreviewContextProvider(props: { children: React.ReactNode }) {
  const { children } = props;
  const [preview] = useQueryParam('preview-dt', StringParam);
  const { start } = useDecisionTreeRunContext();

  React.useEffect(() => {
    if (preview) {
      start(preview, undefined, true);
    }
  }, [preview]);

  return (
    <DecisionTreePreviewContext.Provider value={!!preview}>
      {children}
    </DecisionTreePreviewContext.Provider>
  );
}
